// @flow
import React from 'react';
import { Link } from 'react-router-dom';
import './QuoteActionButtons.scss';

type Props = {
  id: string,
  onAskRemove: () => void,
};

const QuoteActionButtons = ({ id, onAskRemove }: Props) => (
  <div className="QuoteActionButtons">
    <Link to={`/write?edit_id=${id}&type=quote`} className="btn">
      수정
    </Link>
    <button className="btn" onClick={onAskRemove}>
      삭제
    </button>
  </div>
);

export default QuoteActionButtons;



// WEBPACK FOOTER //
// ./src/components/quote/QuoteActionButtons/QuoteActionButtons.js